// Firebase configuration

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB8NY5y80U8J78IkX9iVFKguh8-UC0ZG9k",
  authDomain: "unitade1.firebaseapp.com",
  projectId: "unitade1",
  storageBucket: "unitade1.firebasestorage.app",
  messagingSenderId: "675901174675",
  appId: "1:675901174675:web:d93d7c5a1064d6414b6e66",
  measurementId: "G-R37EXYNZG5"
};

// Initialize Firebase
console.log('Initializing Firebase with config:', firebaseConfig);
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const storage = getStorage(app);
// Explicitly set the Cloud Functions region to us-central1
const functions = getFunctions(app, 'us-central1');
const db = getFirestore(app);



// Verify Firebase initialization
console.log('Firebase App initialized:', app.name);
console.log('Firestore instance created:', db);

// Export all services
export { 
  app, 
  auth, 
  db, 
  storage, 
  functions 
};
